/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#1A1A1A";
export const ColorTextPrimaryInverted = "#FFFFFF";
export const ColorTextSecondary = "#1A1A1AAE";
export const ColorTextSecondaryInverted = "#FFFFFFa3";
export const ColorTextBrand = "#002643";
export const ColorTextBrandInverted = "#FFFFFF";
export const ColorTextDisabled = "#1A1A1A43";
export const ColorTextDisabledInverted = "#FFFFFF57";
export const ColorTextInactive = "#1A1A1A66";
export const ColorTextActive = "#002643";
export const ColorTextLink = "#1A1A1A";
export const ColorTextLinkInverted = "#FFFFFF";
export const ColorTextLinkHover = "#1A1A1A94";
export const ColorTextLinkHoverInverted = "#FFFFFFa3";
export const ColorTextSale = "#DD1D4D";
export const ColorTextSuccess = "#32852D";
export const ColorTextOnSuccessLight = "#275724";
export const ColorTextOnSuccess = "#FFFFFF";
export const ColorTextError = "#DA2828";
export const ColorTextOnErrorLight = "#981C1C";
export const ColorTextOnError = "#FFFFFF";
export const ColorTextWarning = "#AE600E";
export const ColorTextOnWarningLight = "#803A13";
export const ColorTextOnWarning = "#FFFFFF";
export const ColorTextInfo = "#6D6D6D";
export const ColorTextOnInfoLight = "#5D5D5D";
export const ColorTextOnInfo = "#FFFFFF";
export const ColorIconPrimary = "#1A1A1A";
export const ColorIconPrimaryInverted = "#FFFFFF";
export const ColorIconSecondary = "#1A1A1A94";
export const ColorIconSecondaryInverted = "#FFFFFFa3";
export const ColorIconBrand = "#002643";
export const ColorIconBrandInverted = "#FFFFFF";
export const ColorIconDisabled = "#1A1A1A43";
export const ColorIconDisabledInverted = "#FFFFFF57";
export const ColorIconInactive = "#1A1A1A66";
export const ColorIconActive = "#1A1A1A";
export const ColorIconSuccess = "#32852D";
export const ColorIconOnSuccessLight = "#275724";
export const ColorIconOnSuccess = "#FFFFFF";
export const ColorIconError = "#DA2828";
export const ColorIconOnErrorLight = "#981C1C";
export const ColorIconOnError = "#FFFFFF";
export const ColorIconWarning = "#AE600E";
export const ColorIconOnWarningLight = "#803A13";
export const ColorIconOnWarning = "#FFFFFF";
export const ColorIconInfo = "#6D6D6D";
export const ColorIconOnInfoLight = "#5D5D5D";
export const ColorIconOnInfo = "#FFFFFF";
export const ColorIconFocus = "#1A1A1A";
export const ColorIconFavorite = "#F91E1E";
export const ColorIconHover = "#1A1A1A";
export const ColorBackgroundPrimary = "#FFFFFF";
export const ColorBackgroundSecondary = "#EFEDEA";
export const ColorBackgroundBrand = "#002643";
export const ColorBackgroundNeutral = "#DEDFDF";
export const ColorBackgroundOverlay = "#1A1A1A43";
export const ColorBackgroundInactive = "#FFFFFF";
export const ColorBackgroundActive = "#1A1A1A0A";
export const ColorBackgroundHover = "#1A1A1A1A";
export const ColorBackgroundPressed = "#1A1A1A1A";
export const ColorBackgroundFocus = "#1A1A1A31";
export const ColorBackgroundDisabled = "#EAEBEB";
export const ColorBackgroundSuccess = "#32852D";
export const ColorBackgroundSuccessLight = "#C9ECC6";
export const ColorBackgroundError = "#DA2828";
export const ColorBackgroundErrorLight = "#FDCBCB";
export const ColorBackgroundWarning = "#AE600E";
export const ColorBackgroundWarningLight = "#F7E090";
export const ColorBackgroundInfo = "#6D6D6D";
export const ColorBackgroundInfoLight = "#F6F6F6";
export const ColorBorderPrimary = "#1A1A1A66";
export const ColorBorderPrimaryInverted = "#FFFFFF85";
export const ColorBorderSecondary = "#1A1A1A31";
export const ColorBorderSecondaryInverted = "#FFFFFF33";
export const ColorBorderTertiary = "#1A1A1A1A";
export const ColorBorderTertiaryInverted = "#FFFFFF1a";
export const ColorBorderBrand = "#002643";
export const ColorBorderDefault = "#1A1A1A43";
export const ColorBorderFocus = "#002643";
export const ColorBorderHover = "#1A1A1A";
export const ColorBorderDisabled = "#1A1A1A1A";
export const ColorBorderFocusRing = "#1A1A1A";
export const ColorBorderFocusRingInverted = "#FFFFFF";
export const ColorBorderSuccess = "#32852D";
export const ColorBorderWarning = "#AE600E";
export const ColorBorderError = "#DA2828";
export const ColorBorderInfo = "#6D6D6D";
export const Spacing2 = "2px";
export const Spacing4 = "4px";
export const Spacing6 = "6px";
export const Spacing8 = "8px";
export const Spacing12 = "12px";
export const Spacing16 = "16px";
export const Spacing20 = "20px";
export const Spacing24 = "24px";
export const Spacing28 = "28px";
export const Spacing32 = "32px";
export const Spacing40 = "40px";
export const Spacing48 = "48px";
export const Spacing56 = "56px";
export const Spacing64 = "64px";
export const Spacing72 = "72px";
export const Spacing80 = "80px";
export const Spacing88 = "88px";
export const Spacing96 = "96px";
export const Spacing104 = "104px";
export const Spacing112 = "112px";
export const Spacing120 = "120px";
export const TypographyFamilyPrimary = "Inter, sans-serif";
export const TypographyFamilySecondary = "DM_Serif_Text, serif";
export const TypographyHeadlineWeight = 400;
export const TypographyHeadlineSizeXxxl = "4rem";
export const TypographyHeadlineSizeXxl = "3.4285714285714284rem";
export const TypographyHeadlineSizeXl = "2.857142857142857rem";
export const TypographyHeadlineSizeLarge = "2.2857142857142856rem";
export const TypographyHeadlineSizeMedium = "2rem";
export const TypographyHeadlineSizeSmall = "1.7142857142857142rem";
export const TypographyHeadlineSizeXs = "1.4285714285714286rem";
export const TypographyHeadlineSizeXxs = "1.2857142857142858rem";
export const TypographyTitleWeight = 600;
export const TypographyTitleSizeXl = "1.7142857142857142rem";
export const TypographyTitleSizeLarge = "1.4285714285714286rem";
export const TypographyTitleSizeMedium = "1.2857142857142858rem";
export const TypographyTitleSizeSmall = "1.1428571428571428rem";
export const TypographyBodyWeightDefault = 400;
export const TypographyBodyWeightStrong = 600;
export const TypographyBodySizeLarge = "1.1428571428571428rem";
export const TypographyBodySizeMedium = "1rem";
export const TypographyBodySizeSmall = "0.8571428571428571rem";
export const TypographyLabelWeightDefault = 400;
export const TypographyLabelWeightStrong = 600;
export const TypographyLabelSizeLarge = "1.1428571428571428rem";
export const TypographyLabelSizeMedium = "1rem";
export const TypographyLabelSizeSmall = "0.8571428571428571rem";
export const TypographyLinkWeightDefault = 400;
export const TypographyLinkWeightStrong = 600;
export const TypographyLinkSizeLarge = "1.1428571428571428rem";
export const TypographyLinkSizeMedium = "1rem";
export const TypographyLinkSizeSmall = "0.8571428571428571rem";
export const RadiusSmall = "4px";
export const RadiusMedium = "8px";
export const RadiusLarge = "16px";
export const RadiusFull = "100vw";
export const ComponentsCtaRadiusSmall = "8px";
export const ComponentsCtaRadiusMedium = "8px";
export const ComponentsCtaRadiusLarge = "8px";
export const ComponentsCtaPrimaryTextDefault = "#FFFFFF";
export const ComponentsCtaPrimaryIconDefault = "#FFFFFF";
export const ComponentsCtaPrimaryBgDefault = "#002643";
export const ComponentsCtaPrimaryBgHover = "#335169";
export const ComponentsCtaPrimaryBgPressed = "#335169";
export const ComponentsCtaPrimaryBgFocused = "#667D8E";
export const ComponentsCtaPrimaryBorderDefault = "transparent";
export const ComponentsCtaPrimaryBorderHover = "transparent";
export const ComponentsCtaPrimaryBorderPressed = "transparent";
export const ComponentsCtaPrimaryBorderFocus = "transparent";
export const ComponentsCtaPrimaryInvertedTextDefault = "#002643";
export const ComponentsCtaPrimaryInvertedIconDefault = "#002643";
export const ComponentsCtaPrimaryInvertedBgDefault = "#FFFFFF";
export const ComponentsCtaPrimaryInvertedBgHover = "#FFFFFFd9";
export const ComponentsCtaPrimaryInvertedBgPressed = "#FFFFFFd9";
export const ComponentsCtaPrimaryInvertedBgFocused = "#FFFFFFc4";
export const ComponentsCtaPrimaryInvertedBorderDefault = "transparent";
export const ComponentsCtaPrimaryInvertedBorderHover = "transparent";
export const ComponentsCtaPrimaryInvertedBorderPressed = "transparent";
export const ComponentsCtaPrimaryInvertedBorderFocus = "transparent";
export const ComponentsCtaSecondaryTextDefault = "#1A1A1A";
export const ComponentsCtaSecondaryIconDefault = "#1A1A1A";
export const ComponentsCtaSecondaryBgDefault = "#1A1A1A1A";
export const ComponentsCtaSecondaryBgHover = "#1A1A1A31";
export const ComponentsCtaSecondaryBgPressed = "#1A1A1A31";
export const ComponentsCtaSecondaryBgFocused = "#1A1A1A43";
export const ComponentsCtaSecondaryBorderDefault = "transparent";
export const ComponentsCtaSecondaryBorderHover = "transparent";
export const ComponentsCtaSecondaryBorderPressed = "transparent";
export const ComponentsCtaSecondaryBorderFocus = "transparent";
export const ComponentsCtaSecondaryInvertedTextDefault = "#FFFFFF";
export const ComponentsCtaSecondaryInvertedIconDefault = "#FFFFFF";
export const ComponentsCtaSecondaryInvertedBgDefault = "#FFFFFF33";
export const ComponentsCtaSecondaryInvertedBgHover = "#FFFFFF57";
export const ComponentsCtaSecondaryInvertedBgPressed = "#FFFFFF57";
export const ComponentsCtaSecondaryInvertedBgFocused = "#FFFFFF85";
export const ComponentsCtaSecondaryInvertedBorderDefault = "transparent";
export const ComponentsCtaSecondaryInvertedBorderHover = "transparent";
export const ComponentsCtaSecondaryInvertedBorderPressed = "transparent";
export const ComponentsCtaSecondaryInvertedBorderFocus = "transparent";
export const ComponentsCtaTertiaryTextDefault = "#002643";
export const ComponentsCtaTertiaryIconDefault = "#002643";
export const ComponentsCtaTertiaryBgDefault = "transparent";
export const ComponentsCtaTertiaryBgHover = "#1A1A1A0A";
export const ComponentsCtaTertiaryBgPressed = "#1A1A1A0A";
export const ComponentsCtaTertiaryBgFocused = "#1A1A1A1A";
export const ComponentsCtaTertiaryBorderDefault = "#1A1A1A31";
export const ComponentsCtaTertiaryBorderHover = "#002643";
export const ComponentsCtaTertiaryBorderPressed = "#002643";
export const ComponentsCtaTertiaryBorderFocus = "#002643";
export const ComponentsCtaTertiaryInvertedTextDefault = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedIconDefault = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedBgDefault = "transparent";
export const ComponentsCtaTertiaryInvertedBgHover = "transparent";
export const ComponentsCtaTertiaryInvertedBgPressed = "transparent";
export const ComponentsCtaTertiaryInvertedBgFocused = "#FFFFFF1a";
export const ComponentsCtaTertiaryInvertedBorderDefault = "#FFFFFF57";
export const ComponentsCtaTertiaryInvertedBorderHover = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedBorderPressed = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedBorderFocus = "#FFFFFF";
export const ComponentsCtaGhostTextDefault = "#1A1A1A";
export const ComponentsCtaGhostIconDefault = "#1A1A1A";
export const ComponentsCtaGhostBgDefault = "transparent";
export const ComponentsCtaGhostBgHover = "#1A1A1A0A";
export const ComponentsCtaGhostBgPressed = "#1A1A1A0A";
export const ComponentsCtaGhostBgFocused = "#1A1A1A1A";
export const ComponentsCtaGhostBorderDefault = "transparent";
export const ComponentsCtaGhostBorderHover = "transparent";
export const ComponentsCtaGhostBorderPressed = "transparent";
export const ComponentsCtaGhostBorderFocus = "transparent";
export const ComponentsCtaGhostInvertedTextDefault = "#FFFFFF";
export const ComponentsCtaGhostInvertedIconDefault = "#FFFFFF";
export const ComponentsCtaGhostInvertedBgDefault = "transparent";
export const ComponentsCtaGhostInvertedBgHover = "#FFFFFF1a";
export const ComponentsCtaGhostInvertedBgPressed = "#FFFFFF1a";
export const ComponentsCtaGhostInvertedBgFocused = "#FFFFFF33";
export const ComponentsCtaGhostInvertedBorderDefault = "transparent";
export const ComponentsCtaGhostInvertedBorderHover = "transparent";
export const ComponentsCtaGhostInvertedBorderPressed = "transparent";
export const ComponentsCtaGhostInvertedBorderFocus = "transparent";
export const ComponentsCtaInlineText = "#1A1A1A";
export const ComponentsCtaInlineBg = "transparent";
export const ComponentsCtaInlineTextHover = "#1A1A1A94";
export const ComponentsCtaInlineTextFocus = "#1A1A1AD0";
export const ComponentsCtaInlineTextPressed = "#1A1A1AD0";
export const ComponentsCtaInlineTextDisabled = "#1A1A1A43";
export const ComponentsCtaInlineBorderFocus = "#1A1A1A";
export const ComponentsCtaInlineSecondaryText = "#1A1A1A94";
export const ComponentsCtaInlineSecondaryBg = "transparent";
export const ComponentsCtaInlineSecondaryTextHover = "#1A1A1A";
export const ComponentsCtaInlineSecondaryTextFocus = "#1A1A1AD0";
export const ComponentsCtaInlineSecondaryTextPressed = "#1A1A1AD0";
export const ComponentsCtaInlineSecondaryTextDisabled = "#1A1A1A43";
export const ComponentsCtaInlineSecondaryBorderFocus = "#1A1A1A";
export const ComponentsCtaInlineInvertedText = "#FFFFFF";
export const ComponentsCtaInlineInvertedBg = "transparent";
export const ComponentsCtaInlineInvertedTextHover = "#FFFFFFa3";
export const ComponentsCtaInlineInvertedTextFocus = "#FFFFFFcf";
export const ComponentsCtaInlineInvertedTextPressed = "#FFFFFFd9";
export const ComponentsCtaInlineInvertedTextDisabled = "#1A1A1A43";
export const ComponentsCtaInlineInvertedBorderFocus = "#FFFFFF";
export const ComponentsCtaNavigationText = "#1A1A1A";
export const ComponentsCtaNavigationBg = "#FFFFFF";
export const ComponentsCtaNavigationBgHover = "#EAEBEB";
export const ComponentsCtaNavigationBgFocus = "#DEDFDF";
export const ComponentsCtaNavigationBgPressed = "#DEDFDF";
export const ComponentsCtaDisabledTextDisabled = "#1A1A1A43";
export const ComponentsCtaDisabledIconDisabled = "#1A1A1A43";
export const ComponentsCtaDisabledBgDisabled = "#1A1A1A0A";
export const ComponentsCtaDisabledBorderDisabled = "transparent";
export const ComponentsRatingActive = "#1A1A1A";
export const ComponentsRatingInactive = "#1A1A1A31";
export const ComponentsRatingStroke = "#FFFFFF";
export const ComponentsMenuBg = "#EFEDEA";
export const ComponentsMenuText = "#000000";
export const ComponentsMenuHeadline = "#666666";
export const ComponentsMenuDivider = "#E8E3E0";
export const AssetsFeaturedFooterMedicalPictogram =
  "/images/splashes/MedicalCross.svg";
